import React from 'react';
import { connect } from 'react-redux';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NavAdhocMain.css';

const NavAdhocMain = ({appInfo}) => {
  return (
    <div className="AdhocMain">
      <Navbar bg="viitai" expand="lg">
        <Navbar.Brand>BPS ADHOC REQUEST</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
        </Navbar.Collapse>
        <a href={ appInfo.previous_adhoc_request_link } 
          className="prev-req-link"
          target="_blank" rel="noopener noreferrer" >
          adhoc requests before { appInfo.previous_adhoc_request_date }
        </a>
      </Navbar>
    </div>
  );
}

const mapState = state => ({
  appInfo: state.appInfo,
})

const mapDispatch = dispatch => ({
})

export default connect(mapState, mapDispatch)(NavAdhocMain);
